// Fragment « divers » : À Propos, Contact, avis clients, bandeau cookies.
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
export default {
  // ---- À Propos (pages/About.jsx) ----
  'apropos.seo.titre': 'À Propos',
  'apropos.seo.description': "Découvrez l'histoire de Mirum Games et notre passion pour créer des moments magiques en famille avec Joyful Reveal, les puzzles avec matériaux de qualité.",
  'apropos.hero.badge': '🎮 Notre Histoire',
  'apropos.hero.titre': 'Bienvenue chez Mirum Games',
  'apropos.hero.texte': "Nous créons des moments magiques pour célébrer l'arrivée de votre bébé et partager cette joie en famille.",
  'apropos.mission.titre': 'Notre Mission',
  'apropos.mission.texte1': "Chez Mirum Games, nous croyons que les moments importants de la vie méritent d'être célébrés de manière unique et mémorable. Notre mission est de créer des expériences festives et interactives qui transforment la révélation du sexe de bébé en un moment inoubliable de partage en famille.",
  'apropos.mission.texte2': 'Chaque puzzle est conçu avec soin pour créer un moment de suspense et de joie, garantissant une qualité exceptionnelle et une expérience mémorable pour toute la famille.',
  'apropos.mission.encart.titre': 'Célébration Ludique',
  'apropos.mission.encart.texte': 'Transformer la révélation en un jeu de questions-réponses amusant et participatif',
  'apropos.mission.carte1.titre': 'Suspense',
  'apropos.mission.carte1.texte': "Créer un moment de suspense et d'anticipation mémorable",
  'apropos.mission.carte2.titre': 'Festivité',
  'apropos.mission.carte2.texte': 'Transformer la révélation en un événement festif et mémorable',
  'apropos.mission.carte3.titre': 'Partage',
  'apropos.mission.carte3.texte': 'Moments de qualité en famille',
  'apropos.valeurs.titre': 'Nos Valeurs Fondamentales',
  'apropos.valeurs.soustitre': 'Les principes qui guident chacune de nos décisions',
  'apropos.valeurs.excellence.titre': 'Excellence',
  'apropos.valeurs.excellence.texte': 'Nous ne faisons jamais de compromis sur la qualité. Chaque détail compte, de la conception à la finition du puzzle.',
  'apropos.valeurs.creativite.titre': 'Créativité',
  'apropos.valeurs.creativite.texte': 'Nous innovons constamment pour créer des expériences de révélation uniques et mémorables qui marquent les esprits.',
  'apropos.valeurs.authenticite.titre': 'Authenticité',
  'apropos.valeurs.authenticite.texte': 'Nous restons vrais dans nos valeurs et notre engagement envers nos clients et la communauté.',
  'apropos.valeurs.innovation.titre': 'Innovation',
  'apropos.valeurs.innovation.texte': 'Nous explorons constamment de nouvelles façons de créer des expériences de célébration exceptionnelles.',
  'apropos.valeurs.emotions.titre': 'Émotions',
  'apropos.valeurs.emotions.texte': "Nous créons des moments chargés d'émotion qui resteront gravés dans les mémoires de toute la famille.",
  'apropos.valeurs.passion.titre': 'Passion',
  'apropos.valeurs.passion.texte': 'Nous sommes passionnés par ce que nous faisons et cela se reflète dans chaque produit.',
  'apropos.reseaux.titre': 'Nos Réseaux Sociaux',
  'apropos.reseaux.soustitre': 'Rejoignez notre communauté et découvrez les coulisses',
  'apropos.reseaux.instagram.texte': 'Découvrez nos dernières créations, les coulisses de nos puzzles et partagez vos moments magiques avec #MirumGames',
  'apropos.reseaux.facebook.texte': 'Rejoignez notre communauté, participez aux concours et restez informé de nos offres exclusives et nouveautés',
  'apropos.processus.titre': 'Notre Processus de Création',
  'apropos.processus.soustitre': "De l'idée à votre maison",
  'apropos.processus.etape1.titre': 'Recherche & Idéation',
  'apropos.processus.etape1.texte': 'Nous écoutons les retours des futurs parents et organisateurs de gender reveal parties pour créer des expériences toujours plus mémorables.',
  'apropos.processus.etape2.titre': 'Conception & Tests',
  'apropos.processus.etape2.texte': 'Notre équipe conçoit chaque puzzle et effectue des tests rigoureux pour garantir une expérience ludique et mémorable.',
  'apropos.processus.etape3.titre': 'Fabrication',
  'apropos.processus.etape3.texte': 'Chaque puzzle est fabriqué avec soin et attention aux détails pour garantir une qualité premium.',
  'apropos.processus.etape4.titre': 'Qualité & Expédition',
  'apropos.processus.etape4.texte': "Chaque jeu passe par un contrôle qualité stricte avant d'être expédié avec soin chez vous.",
  'apropos.cta.titre': 'Prêt à explorer nos jeux ?',
  'apropos.cta.texte': 'Découvrez notre collection complète et transformez la révélation du sexe de votre bébé en un moment magique et inoubliable.',
  'apropos.cta.boutique': '🛍️ Découvrir la Boutique',
  'apropos.cta.contact': '💬 Nous Contacter',

  // ---- Contact (pages/Contact.jsx) ----
  'contact.seo.titre': 'Contact',
  'contact.seo.description': 'Contacte Mirum Games pour toute question sur Joyful Reveal, notre jeu Joyful Reveal, ou tes commandes. Réponse rapide garantie.',
  'contact.hero.badge': '💬 Restons Connectés',
  'contact.hero.titre': 'Nous Aimerions vous Entendre',
  'contact.hero.texte': "Des questions? Des suggestions? N'hésitez pas à nous contacter. Nous répondons généralement dans les 24 heures.",
  'contact.cartes.email.titre': 'Email',
  'contact.cartes.email.texte': 'Réponse en 24-48h',
  'contact.cartes.adresse.titre': 'Adresse',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, Belgique',
  'contact.cartes.faq.titre': 'Questions ?',
  'contact.cartes.faq.texte': 'Consultez notre FAQ',
  'contact.cartes.faq.soustexte': 'Réponses instantanées',
  'contact.formulaire.titre': 'Envoyez-nous un Message',
  'contact.formulaire.nom': 'Votre Nom',
  'contact.formulaire.nomPlaceholder': 'Jean Dupont',
  'contact.formulaire.email': 'Email',
  'contact.formulaire.emailPlaceholder': 'votre@email.com',
  'contact.formulaire.sujet': 'Sujet',
  'contact.formulaire.sujetPlaceholder': '-- Choisissez un sujet --',
  'contact.formulaire.sujetCommande': 'Question sur ma commande',
  'contact.formulaire.sujetProduit': 'Question sur un produit',
  'contact.formulaire.sujetLivraison': 'Question de livraison',
  'contact.formulaire.sujetPartenariat': 'Partenariat',
  'contact.formulaire.sujetAutre': 'Autre',
  'contact.formulaire.message': 'Message',
  'contact.formulaire.messagePlaceholder': 'Votre message ici...',
  'contact.formulaire.envoiEnCours': '⏳ Envoi...',
  'contact.formulaire.envoyer': '📬 Envoyer le Message',
  'contact.formulaire.succes': '✨ Merci pour votre message! Nous vous répondrons très vite.',
  'contact.faq.titre': 'Questions Fréquentes',
  'contact.faq.soustitre': 'Vous trouverez peut-être votre réponse ici',
  'contact.faq.q1': '❓ Combien de temps pour la livraison?',
  'contact.faq.a1': "Nos commandes partent de Belgique en 1 jour ouvrable en moyenne. Comptez ensuite 1 à 2 jours ouvrables pour le Luxembourg, la Belgique et les Pays-Bas, 2 à 4 jours pour la France et l’Allemagne, 4 à 5 jours pour l’Espagne.",
  'contact.faq.q2': '🎁 Puis-je ajouter un message personnalisé?',
  'contact.faq.a2': 'Bien sûr! Nos packs premium incluent une carte personnalisée. Contactez-nous après votre commande pour les détails.',
  'contact.faq.q3': '💰 Avez-vous une garantie?',
  'contact.faq.a3': 'Oui ! Vous avez 14 jours pour retourner un produit qui ne vous convient pas. De plus, nous garantissons tous nos produits contre les défauts cachés.',
  'contact.faq.q4': "🌍 Livrez-vous à l'international?",
  'contact.faq.a4': "Nous livrons en Belgique, en France, au Luxembourg, aux Pays-Bas, en Allemagne et en Espagne. Vous choisissez au moment de la commande entre la livraison à domicile et un point relais, selon les transporteurs disponibles à votre adresse.",
  'contact.faq.q5': '🎮 Comment fonctionne le puzzle?',
  'contact.faq.a5': "C'est un jeu de questions-réponses amusant qui guide l'assemblage du puzzle. En répondant correctement, vous assemblez les pièces et découvrez le sexe de bébé !",
  'contact.faq.q6': '🎊 Combien de personnes peuvent jouer?',
  'contact.faq.a6': 'Le puzzle est conçu pour être partagé en famille ! Vous pouvez former des équipes et jouer à plusieurs pour rendre le moment encore plus festif.',
  'contact.newsletter.titre': 'Restez Informé',
  'contact.newsletter.texte': 'Inscrivez-vous à notre newsletter pour recevoir les dernières offres et actualités',
  'contact.newsletter.emailPlaceholder': 'votre@email.com',
  'contact.newsletter.inscrire': "S'inscrire",
  'contact.newsletter.succes': '✨ Bienvenue dans notre newsletter!',

  // ---- Avis clients (components/Reviews/*) ----
  // Le CONTENU des avis (texte, titre, nom d'auteur) vient de la base et
  // n'est jamais traduit ; seul l'habillage passe par ces clés.
  'avis.section.badge': '💬 Expériences Clients',
  'avis.section.titre': 'Ce que nos clients adorent',
  'avis.section.accrocheAucun': 'Vous avez joué ? Racontez-nous votre moment — votre avis aidera les prochains futurs parents à se décider.',
  'avis.section.accrochePeu': 'Ils ont joué avant vous et ont pris le temps de nous écrire. Voici leurs mots, sans filtre.',
  'avis.section.accrocheNombreux': 'Déjà {n} familles ont partagé leur moment avec nous.',
  'avis.section.compteurSingulier': 'avis',
  'avis.section.compteurPluriel': 'avis',
  'avis.section.premierAvis': 'Soyez le premier à donner votre avis !',
  'avis.section.fermer': '✕ Fermer',
  'avis.section.laisserAvis': '✍️ Laisser un avis',
  'avis.section.chargement': 'Chargement des avis...',
  'avis.section.listeTitre': 'Les Avis',
  'avis.section.aucunTitre': 'Soyez le premier !',
  'avis.section.aucunTexte': 'Aucun avis pour le moment. Soyez le premier à partager votre expérience magique !',
  'avis.section.ecrirePremier': 'Écrire le premier avis',
  'avis.section.erreurEnvoi': "Erreur lors de l'envoi de l'avis",
  'avis.carte.noteAria': 'Note de {note} sur 5',
  'avis.carte.clientVerifie': 'Client Vérifié',
  'avis.carte.achatVerifie': '✅ Achat Vérifié',
  'avis.formulaire.titre': 'Partagez votre expérience',
  'avis.formulaire.note': 'Note globale',
  'avis.formulaire.noterAria': 'Noter {n} étoiles',
  'avis.formulaire.note5': 'Excellent ! 🤩',
  'avis.formulaire.note4': 'Très bien 🙂',
  'avis.formulaire.note3': 'Bien 😐',
  'avis.formulaire.note2': 'Moyen 😕',
  'avis.formulaire.note1': 'Déçu 😞',
  'avis.formulaire.titreAvis': 'Titre de votre avis',
  'avis.formulaire.titrePlaceholder': 'Ex: Super puzzle, ma fille adore !',
  'avis.formulaire.commentaire': 'Votre commentaire',
  'avis.formulaire.commentairePlaceholder': 'Dites-nous ce que vous avez aimé...',
  'avis.formulaire.envoiEnCours': 'Envoi en cours...',
  'avis.formulaire.publier': 'Publier mon avis',

  // ---- Bandeau cookies (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Gestion des Cookies',
  'cookies.bandeau.texte': "Ce site n'utilise que deux choses : les cookies nécessaires à votre panier et à votre connexion, et une mesure d'audience anonyme, faite par nous, sans cookie et sans jamais vous identifier. Aucune publicité, aucun profilage, aucun partage avec un tiers.",
  'cookies.gerer': "Gérer mes cookies",
  'cookies.categories.necessaires': 'Cookies Nécessaires',
  'cookies.categories.necessairesDesc': 'Toujours activés - Essentiels au fonctionnement du site',
  'cookies.categories.analytics': "Mesure d'audience anonyme",
  'cookies.categories.analyticsDesc': "Nombre de visites et pages consultées. Sans cookie, sans identifiant, votre adresse IP n'est jamais conservée. Vous pouvez la refuser.",
  'cookies.categories.marketing': 'Cookies Marketing',
  'cookies.categories.marketingDesc': 'Pour vous proposer du contenu et des offres personnalisées',
  'cookies.bandeau.voirNotre': 'Voir notre',
  'cookies.bandeau.politique': 'Politique de Confidentialité',
  'cookies.bandeau.plusInfos': "pour plus d'informations",
  'cookies.actions.refuser': 'Tout Refuser',
  'cookies.actions.personnaliser': 'Personnaliser',
  'cookies.actions.accepter': 'Tout Accepter',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Connexion",
  'compte.connexion.seoDescription': "Connectez-vous à votre compte Mirum Games.",
  'compte.connexion.titre': "Connexion",
  'compte.connexion.sousTitre': "Bienvenue chez Mirum Games",
  'compte.champ.email': "Adresse email",
  'compte.champ.emailPlaceholder': "votre@email.com",
  'compte.champ.motDePasse': "Mot de passe",
  'compte.champ.motDePassePlaceholder': "Votre mot de passe",
  'compte.champ.basculerMotDePasse': "Afficher ou masquer le mot de passe",
  'compte.connexion.seSouvenir': "Se souvenir de moi",
  'compte.connexion.motDePasseOublie': "🔑 Mot de passe oublié ?",
  'compte.connexion.bouton': "🔓 Se connecter",
  'compte.connexion.enCours': "⏳ Connexion en cours…",
  'compte.connexion.ouContinuerAvec': "Ou continuer avec",
  'compte.connexion.pasDeCompte': "Pas encore de compte ?",
  'compte.connexion.creerUnCompte': "Créer un compte",
  'compte.connexion.erreur': "Identifiants invalides. Veuillez réessayer.",
  'compte.connexion.erreurGoogle': "Erreur lors de la connexion avec Google.",
  'compte.inscription.seoTitre': "Inscription",
  'compte.inscription.seoDescription': "Créez votre compte Mirum Games.",
  'compte.inscription.titre': "Inscription",
  'compte.inscription.sousTitre': "Rejoignez la communauté Mirum Games",
  'compte.champ.nomComplet': "Nom complet",
  'compte.champ.nomCompletPlaceholder': "Jean Dupont",
  'compte.champ.creerMotDePasse': "Créez un mot de passe sécurisé",
  'compte.champ.confirmation': "Confirmer le mot de passe",
  'compte.champ.confirmationPlaceholder': "Confirmez votre mot de passe",
  'compte.force.faible': "❌ Faible",
  'compte.force.moyen': "⚠️ Moyen",
  'compte.force.fort': "✅ Fort",
  'compte.inscription.accepteLes': "J'accepte les",
  'compte.inscription.conditions': "conditions générales de vente",
  'compte.inscription.etLa': "et la",
  'compte.inscription.politique': "politique de confidentialité",
  'compte.inscription.bouton': "🎮 Créer un compte",
  'compte.inscription.enCours': "⏳ Création en cours…",
  'compte.inscription.dejaUnCompte': "Vous avez déjà un compte ?",
  'compte.inscription.seConnecter': "Se connecter",
  'compte.inscription.erreurMotsDePasse': "Les mots de passe ne correspondent pas.",
  'compte.inscription.erreurConditions': "Veuillez accepter les conditions d'utilisation.",
  'compte.inscription.erreurLongueur': "Le mot de passe doit contenir au moins 6 caractères.",
  'compte.inscription.erreur': "Erreur lors de l'inscription. Veuillez réessayer.",
  'compte.profil.deconnexion': "Déconnexion",
  'compte.profil.mesCommandes': "📦 Mes commandes",
  'compte.profil.informations': "👤 Informations",
  'compte.profil.informationsTitre': "Informations personnelles",
  'compte.commandes.chargement': "Chargement des commandes…",
  'compte.commandes.aucune': "Vous n'avez pas encore passé de commande.",
  'compte.commandes.decouvrir': "Découvrir nos produits",
  'compte.commandes.articles': "Articles :",
  'compte.commandes.total': "Total :",
  'compte.commandes.suiviLabel': "N° de suivi :",
  'compte.commandes.suivre': "Suivre mon colis",
  'compte.commandes.facture': "Télécharger la facture",
  "compte.commandes.noteCredit": "Note de crédit",
  'compte.commandes.avis': "Laisser un avis",
  'compte.commandes.nonAuthentifie': "Session expirée. Veuillez vous reconnecter.",
  'compte.commandes.erreur': "Erreur lors du chargement des commandes",
  'compte.statut.paid': "Payée",
  'compte.statut.shipped': "Expédiée",
  'compte.statut.delivered': "Livrée",
  'compte.statut.cancelled': "Annulée",
  'compte.infos.general': "Informations générales",
  'compte.infos.nomComplet': "Nom complet *",
  'compte.infos.emailFige': "L'email ne peut pas être modifié",
  'compte.infos.adresseLivraison': "Adresse de livraison",
  'compte.infos.adresse': "Adresse",
  'compte.infos.adressePlaceholder': "Numéro et nom de rue",
  'compte.infos.ville': "Ville",
  'compte.infos.codePostal': "Code postal",
  'compte.infos.pays': "Pays",
  'compte.infos.choisirPays': "Choisir un pays",
  'compte.infos.telephone': "Téléphone",
  'compte.infos.enregistrer': "💾 Enregistrer",
  'compte.infos.enregistrement': "⏳ Enregistrement…",
  'compte.infos.succes': "✅ Profil mis à jour avec succès !",
  'compte.infos.erreur': "❌ Erreur lors de la mise à jour du profil",
  "maFacture.seoTitre": "Retrouver ma facture - Mirum Games",
  "maFacture.seoDescription": "Retrouvez la facture de votre commande Mirum Games avec votre numéro de commande et votre adresse e-mail.",
  "maFacture.titre": "Retrouver ma facture",
  "maFacture.intro": "Vous avez commandé sans compte et vous ne retrouvez plus l'e-mail de confirmation ? Indiquez votre numéro de commande et l'adresse e-mail utilisée lors de l'achat.",
  "maFacture.champNumero": "Numéro de commande ou de facture",
  "maFacture.champNumeroAide": "Il figure dans l'e-mail de confirmation et sur la page affichée après le paiement.",
  "maFacture.champEmail": "Adresse e-mail utilisée lors de l'achat",
  "maFacture.bouton": "Retrouver ma facture",
  "maFacture.recherche": "Recherche…",
  "maFacture.introuvable": "Nous ne trouvons pas de commande à ce nom. Vérifiez le numéro et l'adresse e-mail utilisée lors de l'achat.",
  "maFacture.tropDEssais": "Trop d'essais d'affilée. Patientez une minute, puis réessayez.",
  "maFacture.erreur": "La recherche n'a pas abouti. Réessayez dans un instant ou écrivez-nous.",
  "maFacture.facture": "Votre facture n° {numero} est prête.",
  "maFacture.voirFacture": "🧾 Voir et imprimer la facture",
  "maFacture.langueDocument": "Vous pouvez l'imprimer ou l'enregistrer en PDF depuis votre navigateur.",
  "maFacture.factureStripe": "🧾 Voir la facture de cette commande",
  "maFacture.enAttente": "Votre paiement n'est pas encore arrivé : la facture vous sera envoyée par e-mail dès sa réception.",
  "maFacture.aucune": "Cette commande n'a pas de facture en ligne. Écrivez-nous, nous vous l'enverrons.",
  "maFacture.voirNote": "Note de crédit n° {numero}",
  "maFacture.compte": "Vous avez un compte ? Toutes vos factures sont dans",
};
